export default {
    PROCEDIMENTOS: 1,
    GERAL_E_INESPECIFICO: 2,
    SANGUE_SISTEMA_HEMATOPOIETICO_LINFATICO_E_BACO: 3,
    DIGESTIVO: 4,
    OLHO: 5,
    OUVIDO: 6,
    CIRCULATORIO: 7,
    MUSCULOSQUELETICO: 8,
    NEUROLOGICO: 9,
    PSICOLOGICO: 10,
    RESPIRATORIO: 11,
    PELE: 12,
    ENDOCRINO_METABOLICO_E_NUTRICIONAL: 13,
    URINARIO: 14,
    GRAVIDEZ_PARTO_E_PLANEJAMENTO_FAMILIAR: 15,
    GENITAL_FEMININO: 16,
    GENITAL_MASCULINO: 17,
    PROBLEMAS_SOCIAIS: 18
};